import React, { FC } from 'react';
import { CategoryType } from '../../../models/category-type';
import HeroTextBanner from '../hero-text-banner/hero-text-banner';

interface CategoryLandingHeadingProps {
  readonly category: CategoryType;
}

const CategoryLandingHeading: FC<CategoryLandingHeadingProps> = ({
  category,
}: CategoryLandingHeadingProps) => (
  <HeroTextBanner
    headline={category.name}
    headingSize="h2"
    description={category.description}
    subHeading={category.parentCategory?.name}
  />
);

export default CategoryLandingHeading;
